const faq = [
  {
    path: '/faq',
    name: 'faq-admin',
    component: () => import('@/views/faq/Faq.vue'),
    meta: {
      layout: 'content',
      action: 'read',
      resource: 'FaqAdmin',
    },
  },
]
export default faq
